import React from 'react';
import { useParams } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { LandingHeader } from '../components/LandingHeader';
import { blogPosts, findPost, formatPostDate } from '../data/blogPosts';
import { useScreenInit } from '../useScreenInit';
export function BlogPostPage() {
  const params = useParams<{
    slug?: string;
  }>();
  const screenInit = useScreenInit() as {
    slug?: string;
  };
  const slug = params.slug || screenInit.slug || blogPosts[0].slug;
  const post = findPost(slug) || blogPosts[0];
  const related = blogPosts.filter(entry => entry.slug !== post.slug).slice(0, 3);
  return <div id="top" className="min-h-screen w-full bg-white text-[#041F60]" data-id="element-598" data-mp="17god8t5sh0u0">
      <a href="#main-content" className="sr-only fixed left-4 top-4 z-50 rounded-lg bg-[#041F60] px-4 py-2 text-sm font-bold text-white focus:not-sr-only focus:outline-none focus:ring-2 focus:ring-[#4BE4FF]" data-id="element-599" data-mp="1cf94w46z6c6u">
        Skip to content
      </a>
      <LandingHeader data-id="element-600" data-mp="kb4pze7fm9my" />

      <main id="main-content" data-id="element-601" data-mp="kammpxmcqv5j">
        <article data-id="element-602" data-mp="kbxr9znmg6xp">
          <header className="border-b border-[#A6B6F8]/50 bg-[#A6B6F8]/20" data-id="element-603" data-mp="k9be9khyoz83">
            <div className="mx-auto max-w-3xl px-5 py-12 sm:px-8 sm:py-16" data-id="element-604" data-mp="gbdskrnegv9g">
              <a href="/blog" className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#5B5299] transition hover:text-[#041F60] focus:underline focus:outline-none" data-id="element-605" data-mp="u29308djrkf5">
                <ArrowLeftIcon size={15} aria-hidden="true" data-id="element-606" data-mp="13xk9k3esxlbt" /> All articles
              </a>
              <p className="mt-7 text-xs font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-607" data-mp="yzsfb2qopn4g">
                {post.category}
              </p>
              <h1 className="mt-3 text-3xl font-bold tracking-[-0.04em] sm:text-[2.75rem] sm:leading-[1.08]" data-id="element-608" data-mp="1818h4m3fogx2">
                {post.title}
              </h1>
              <p className="mt-5 text-lg leading-8 text-[#3A3A3A]" data-id="element-609" data-mp="3erorgwpamx1m">
                {post.standfirst}
              </p>
              <div className="mt-7 flex flex-wrap items-center gap-x-3 gap-y-1 border-t border-[#A6B6F8]/60 pt-5 text-sm text-stone-600" data-id="element-610" data-mp="39upwyd1pwo2w">
                <span className="font-semibold text-[#041F60]" data-id="element-611" data-mp="1inidafbt25u1">
                  {post.author}
                </span>
                <span aria-hidden="true" data-id="element-612" data-mp="1nmlj41zm0g32">·</span>
                <time dateTime={post.date} data-id="element-613" data-mp="1rp00ehnmr7s8">{formatPostDate(post.date)}</time>
                <span aria-hidden="true" data-id="element-614" data-mp="1rmvn593ucwfa">·</span>
                <span data-id="element-615" data-mp="1wous2nf8c1ec">{post.readingMinutes} min read</span>
              </div>
            </div>
          </header>

          <div className="mx-auto max-w-3xl px-5 py-14 sm:px-8 sm:py-16" data-id="element-616" data-mp="21m4gbzqvu70l">
            {post.body.map(section => <section key={section.heading} className="mt-12 first:mt-0" data-id="element-617" data-mp="26eebbu6utx9q">
                <h2 className="text-xl font-bold tracking-tight sm:text-2xl" data-id="element-618" data-mp="2bbxo0pnwm1zk">
                  {section.heading}
                </h2>
                {section.paragraphs.map(paragraph => <p key={paragraph} className="mt-4 text-base leading-8 text-[#3A3A3A]" data-id="element-619" data-mp="2kcvsf9298bio">
                    {paragraph}
                  </p>)}
                {section.bullets && <ul className="mt-5 space-y-3 border-l-2 border-[#4BE4FF] pl-5" data-id="element-620" data-mp="3vv04bxin9xtn">
                    {section.bullets.map(bullet => <li key={bullet} className="text-base leading-7 text-[#3A3A3A]" data-id="element-621" data-mp="3qwymth0va6ka">
                        {bullet}
                      </li>)}
                  </ul>}
              </section>)}
          </div>
        </article>

        <section className="border-t border-[#A6B6F8]/50 bg-white" data-id="element-622" data-mp="im548xd5vymo">
          <div className="mx-auto max-w-6xl px-5 py-14 sm:px-8 sm:py-16" data-id="element-623" data-mp="dovipssw8744">
            <h2 className="text-sm font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-624" data-mp="1b51284oa6iyy">
              Read next
            </h2>
            <ul className="mt-8 grid gap-5 md:grid-cols-3" data-id="element-625" data-mp="16crdgrywjoy9">
              {related.map(entry => <li key={entry.slug} className="h-full" data-id="element-626" data-mp="px8gxgjwcxd1">
                  <article className="flex h-full flex-col rounded-2xl border border-[#A6B6F8]/50 bg-white p-6" data-id="element-627" data-mp="uxwgiqm6ymiv">
                    <p className="text-xs font-bold uppercase tracking-[0.12em] text-[#5B5299]" data-id="element-628" data-mp="gywp5b7antj0">
                      {entry.category}
                    </p>
                    <h3 className="mt-3 text-lg font-bold leading-snug tracking-tight" data-id="element-629" data-mp="19miy6yzajqd9">
                      <a href={`/blog/${entry.slug}`} className="underline-offset-4 hover:underline focus:underline focus:outline-none" data-id="element-630" data-mp="19owqj02l6oh4">
                        {entry.title}
                      </a>
                    </h3>
                    <p className="mt-3 text-sm leading-6 text-[#3A3A3A]" data-id="element-631" data-mp="14thd298hqul8">
                      {entry.excerpt}
                    </p>
                    <p className="mt-auto pt-6 text-xs font-semibold text-stone-500" data-id="element-632" data-mp="1xcd5z24r6oqn">
                      {formatPostDate(entry.date)} · {entry.readingMinutes} min
                      read
                    </p>
                  </article>
                </li>)}
            </ul>
          </div>
        </section>

        <section className="navy-texture border-t border-[#031849] text-white" data-id="element-633" data-mp="2gg8aqqir48cu">
          <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-8 px-5 py-14 sm:px-8 sm:py-20 md:flex-row md:items-center" data-id="element-634" data-mp="2biomqyw94h7p">
            <div className="max-w-xl" data-id="element-635" data-mp="1ntvvhfqkqxjf">
              <h2 className="text-3xl font-bold tracking-[-0.035em] sm:text-4xl" data-id="element-636" data-mp="1jr8xsy782ieb">
                Put this into practice.
              </h2>
              <p className="mt-3 text-base leading-7 text-[#A6B6F8]" data-id="element-637" data-mp="1xo5pf1v603w9">
                Start your free trial and bring credit, collections and invoice
                finance into one practical view.
              </p>
            </div>
            <a href="/signup" className="inline-flex shrink-0 items-center gap-2 rounded-lg bg-[#4BE4FF] px-5 py-3.5 text-sm font-bold text-[#041F60] transition hover:bg-[#38d9f2] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#041F60]" data-id="element-638" data-mp="346kpak8i53ce">
              Start your free trial{' '}
              <ArrowRightIcon size={17} aria-hidden="true" data-id="element-639" data-mp="3l8hyel9g5jpp" />
            </a>
          </div>
        </section>
      </main>

      <footer className="bg-white" data-id="element-640" data-mp="2sj16dopqo4u0">
        <div className="mx-auto flex max-w-6xl flex-col gap-5 px-5 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-641" data-mp="2sjstsc96mw97">
          <p className="text-sm font-semibold text-[#041F60]" data-id="element-642" data-mp="2xinmc5wybz6i">Credit Manager</p>
          <a href="mailto:support@creditmanager.co.uk" className="text-sm font-semibold text-[#5B5299] underline decoration-[#A6B6F8] underline-offset-4 transition hover:text-[#041F60] focus:text-[#041F60] focus:outline-none" data-id="element-643" data-mp="32gfacouh715f">
            Contact support
          </a>
          <p className="text-xs text-stone-500" data-id="element-644" data-mp="2eqbifeqngpu9">© 2026 Credit Manager</p>
        </div>
      </footer>
    </div>;
}